"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spectrumConfigs = void 0;
var _spectrumRgbArray = require("./spectrumRgbArray");
const spectrumConfigs = {
  base: {
    light: _spectrumRgbArray.light,
    dark: _spectrumRgbArray.dark
  }
};
exports.spectrumConfigs = spectrumConfigs;